// Module
var code = `<div class="bot-tips-wrapper"> <div class="bot-tips-container"> <bot-avatar-component bot-type="ctrl.botType"/> <div class="bot-tips-baloon"> <div render-bot-tip class="bot-tip-text"></div> </div> </div> </div> `;
// Exports
export default code;